import { useEffect, useState } from 'react';
import heroBg from '@/assets/hero/hero-bg.jpg';
import logo from '@/assets/logo/logo.png';
export default function HeroSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    // Guard for environments where `window` is not available (e.g., SSR)
    if (typeof window === 'undefined') return;

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    // Cleanup the listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Скролл к контактной секции
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Скролл к секции услуг
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Расчёт эффектов при скролле
  const scrollProgress = Math.min(scrollY / 800, 1);
  const heroOpacity = Math.max(0.2, 1 - scrollProgress * 0.8);
  const heroScale = Math.max(0.9, 1 - scrollProgress * 0.1);
  const contentTranslateY = scrollProgress * 50;
  const overlayOpacity = Math.min(0.85, 0.6 + scrollProgress * 0.25);

  return (
    <section 
      className="relative min-h-screen flex items-center justify-start overflow-hidden z-10"
      style={{
        opacity: heroOpacity,
        transform: `scale(${heroScale})`,
        transition: 'none',
        willChange: 'opacity, transform'
      }}
    >
      {/* Фоновое изображение */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center z-0"
        style={{
          backgroundImage: `url(${heroBg})`
        }}
      ></div>

      {/* Усиленная тёмная маска для лучшей читаемости */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/70 to-black/80 z-10"
        style={{
          opacity: overlayOpacity,
          transition: 'none',
          willChange: 'opacity'
        }}
      ></div>

      <div className="relative z-20 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="max-w-2xl"
          style={{
            transform: `translateY(${contentTranslateY}px)`,
            transition: 'none',
            willChange: 'transform'
          }}
        >
          <div className="space-y-8">
            <div 
              className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 lg:gap-8"
              style={{
                transform: `translateY(${contentTranslateY * 0.5}px)`,
                transition: 'none',
                willChange: 'transform'
              }}
            >
              <div className="inline-block">
                <div 
                  className="backdrop-blur-sm rounded-lg px-4 sm:px-6 lg:px-8 py-3 sm:py-4 lg:py-5 inline-block"
                  style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)' }}
                >
                  <img 
                    src={logo} 
                    alt="Elkostart Logo" 
                    className="h-16 sm:h-20 lg:h-24 xl:h-28 w-auto object-contain"
                  />
                </div>
              </div>

              <p
                className="text-lg sm:text-xl lg:text-2xl text-white leading-relaxed font-light max-w-xl flex-1"
              >
                Комплексные решения в области производства металлоконструкций, рекламы, дизайна и фотографии для вашего бизнеса
              </p>
            </div>

            <div
              className="flex flex-col sm:flex-row gap-6"
              style={{
                transform: `translateY(${contentTranslateY * 0.2}px)`,
                opacity: Math.max(0.3, 1 - scrollProgress * 0.7),
                transition: 'none',
                willChange: 'transform, opacity'
              }}
            >
              <button 
                onClick={scrollToContact}
                className="bg-white text-gray-900 px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer rounded-full shadow-xl"
              >
                Записаться на консультацию
              </button>
              <button 
                onClick={scrollToServices}
                className="px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-light text-white border-2 border-white hover:border-white hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer rounded-full shadow-xl backdrop-blur-sm"
              >
                Узнать подробнее
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
        style={{
          opacity: Math.max(0, 1 - scrollProgress * 2),
          transition: 'none',
          willChange: 'opacity'
        }}
      >
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center shadow-lg">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}